import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ActionBar from "../../../Components/Button/ActionBar";
import NewsMediaForm from "../../../Components/Forms/NewsMediaForm";
import axios from "axios";
import { toast } from "sonner";

export default function UpdateNewsMedia() {
  const location = useLocation();
  const id = location.state && location.state.id;
  const navigate = useNavigate();
  const [role, setRole] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [Year, setYear] = useState("");
  const [Artist, setArtist] = useState("");
  const [Category, setCategory] = useState("");
  const [Title, setTitle] = useState("");
  const [Media, setMedia] = useState("");
  const [DatePosted, setDatePosted] = useState<any | null>(null);
  const [Link, setLink] = useState("");
  const [Thumbnail, setThumbnail] = useState<File | string | null>(null);
  const [thumbnail_name, setThumbnailName] = useState<string>("");

  const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setYear(e.target.value);
  };

  const handleArtistChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setArtist(e.target.value);
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCategory(e.target.value);
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleMediaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMedia(e.target.value);
  };

  const handleDatePostedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDatePosted(e.target.value);
  };

  const handleLinkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLink(e.target.value);
  };

  const handleThumbnailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setThumbnail(e.target.files[0]);
    }
  };

  const fetchData = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/news-media/${id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      const newsMediaData = response.data.NewsMedia;

      console.log("Testing: ", newsMediaData);

      if(newsMediaData) {
        const { Year, Artist, Category, Title, Media, DatePosted, Link, Thumbnail, } = newsMediaData;
        setYear(Year);
        setArtist(Artist);
        setCategory(Category);
        setTitle(Title);
        setMedia(Media);
        setDatePosted(DatePosted);
        setLink(Link);
        setThumbnail(Thumbnail);
      }

      console.log('Testing: ', newsMediaData);
    } catch (error) {
      console.error("Error fetching data:", error);
   
    }
  };

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("Year", Year);
    formData.append("Artist", Artist);
    formData.append("Category", Category);
    formData.append("Title", Title);
    formData.append("Media", Media);
    formData.append("DatePosted", DatePosted);
    formData.append("Link", Link);
  
    if (Thumbnail && typeof Thumbnail !== "string") {
      formData.append("Thumbnail", Thumbnail);
    }

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("Authentication token not found!");
        setIsSubmitting(false);
        return;
      }

      await axios.post(`https://cdn.pulp.ph/api/v1/pulpliveworld/news-media/${id}`,formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      toast.success(<p className="text-[16px]">Content was submitted successfully!</p>, {
        duration: 1500,
      });
      setTimeout(() => {
        navigate("/view/post/news-media");
      }, 1600);
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      alert(`There was an error submitting the form!, ${error}`);
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);
  
  return (
    <>
      <div className="w-full p-5">
          <div className="flex justify-between items-center mb-4">
            <h1 className="GraphikSemibold text-[20px] font-semibold">Edit News & Media</h1>
            <ActionBar
              role={role}
              onSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              isSaved={isSubmitting}
            />
          </div>

          <div className="py-5 px-4 rounded bg-white">
            <NewsMediaForm
              year={Year}
              artist={Artist}
              category={Category}
              title={Title}
              media={Media}
              datePosted={DatePosted}
              link={Link}
              thumbnail={Thumbnail}
              onYearChange={handleYearChange}
              onArtistChange={handleArtistChange}
              onCategoryChange={handleCategoryChange}
              onTitleChange={handleTitleChange}
              onMediaChange={handleMediaChange}
              onDatePostedChange={handleDatePostedChange}
              onLinkChange={handleLinkChange}
              onThumbnailChange={handleThumbnailChange}
            />
          </div>
      </div>
    </>
  )
}